import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const shiftComputed = {
  ...mapGetters('shifts', [
    'shifts',
    'shiftOptions',
    'shiftsAlert',
    'replacements',
  ]),
}

export const userComputed = {
  ...mapGetters('users', ['users', 'usersPagination']),
}

export const kidComputed = {
  ...mapGetters('kids', ['kids']),
}

export const eventComputed = {
  ...mapGetters('events', ['events']),
}

export const dutyComputed = {
  ...mapGetters('duties', ['duties']),
}

export const oncallDutyComputed = {
  ...mapGetters('oncall', ['oncallDuties']),
}

export const registrationComputed = {
  ...mapGetters('registrations', ['registrations']),
}

export const usersStatsComputed = {
  ...mapGetters('usersstats', ['usersStats', 'usersStatsPagination']),
}

export const logComputed = {
  ...mapGetters('logs', ['logs', 'logsPagination']),
}

export const documentComputed = {
  ...mapGetters('documents', ['documents', 'documentsPagination']),
}

export const userFileComputed = {
  ...mapGetters('userfiles', ['userFiles']),
}

export const cityComputed = {
  ...mapGetters('cities', ['cities', 'cityOptions']),
}

export const fileComputed = {
  ...mapGetters('files', ['files']),
}

export const volunteerComputed = {
  ...mapGetters('volunteers', ['volunteers', 'volunteerOptions']),
}

export const hospitalComputed = {
  ...mapGetters('hospitals', ['hospitals', 'hospitalOptions']),
}

export const sourceComputed = {
  ...mapGetters('sources', ['sources', 'sourceOptions']),
}

export const contractComputed = {
  ...mapGetters('contracts', ['contracts']),
}

export const cancelReasonComputed = {
  ...mapGetters('cancelreasons', ['cancelReasons', 'cancelReasonOptions']),
}

export const purposeComputed = {
  ...mapGetters('purposes', ['purposes', 'purposeOptions']),
}

export const notificationComputed = {
  ...mapGetters('notifications', ['notifications']),
}

export const usersFiltersComputed = {
  ...mapGetters('usersfilters', ['usersFilters']),
}

export const groupComputed = {
  ...mapGetters('groups', ['groups', 'groupOptions']),
}

export const uiComputed = {
  ...mapGetters('ui', ['sidebarExpanded', 'isIphone']),
}

export const authMethods = mapActions('auth', [
  'logIn',
  'logOut',
  'remindPassword',
  'passwordChange',
  'reloadLogin',
])

export const userMethods = mapActions('users', [
  'fetchAllUsers',
  'createUser',
  'deleteUser',
  'viewUser',
  'updateUser',
])

export const logMethods = mapActions('logs', [
  'fetchAllLogs',
  'createLog',
  'deleteLog',
  'updateLog',
])

export const documentMethods = mapActions('documents', [
  'fetchAllDocuments',
  'createDocument',
  'viewDocument',
  'deleteDocument',
  'updateDocument',
])

export const fileMethods = mapActions('files', [
  'fetchAllFiles',
  'createFile',
  'createUrl',
  'deleteFile',
])

export const shiftMethods = mapActions('shifts', ['fetchAllShifts'])

export const dutyMethods = mapActions('duties', [
  'fetchAllDuties',
  'createDuty',
  'updateDuty',
  'deleteDuty',
])

export const replacementMethods = mapActions('replacements', [
  'createReplacement',
])

export const kidMethods = mapActions('kids', [
  'fetchAllKids',
  'createKid',
  'viewKid',
  'updateKid',
  'deleteKid',
  'saveKidCount',
])

export const volunteerMethods = mapActions('volunteers', [
  'fetchAllVolunteers',
  'createVolunteer',
  'updateVolunteer',
  'deleteVolunteer',
])

export const eventMethods = mapActions('events', [
  'fetchAllEvents',
  'createEvent',
  'viewEvent',
  'updateEvent',
  'deleteEvent',
])

export const registrationMethods = mapActions('registrations', [
  'fetchAllRegistrations',
  'createRegistration',
  'updateRegistration',
  'deleteRegistration',
])

export const oncallDutyMethods = mapActions('oncall', [
  'fetchAllOncallDuties',
  'createOncallDuty',
  'deleteOncallDuty',
])

export const profileMethods = mapActions('profile', [
  'updateProfile',
  'uploadAvatar',
])

export const usersStatsMethods = mapActions('usersstats', [
  'fetchAllUsersStats',
  'downloadAllUsersStats',
])

export const userFileMethods = mapActions('userfiles', [
  'fetchAllUserFiles',
  'createUserFile',
  'deleteUserFile',
])

export const cityMethods = mapActions('cities', ['fetchAllCities'])

export const hospitalMethods = mapActions('hospitals', ['fetchAllHospitals'])

export const inviteMethods = mapActions('invites', ['createInvite'])

export const sourceMethods = mapActions('sources', ['fetchAllSources'])

export const contractMethods = mapActions('contracts', [
  'fetchAllContracts',
  'deleteContract',
])

export const cancelReasonMethods = mapActions('cancelreasons', [
  'fetchAllCancelReasons',
])

export const purposeMethods = mapActions('purposes', ['fetchAllPurposes'])

export const notificationMethods = mapActions('notifications', [
  'fetchAllNotifications',
  'deleteNotification',
])

export const usersFiltersMethods = mapActions('usersfilters', [
  'setUsersFilters',
])

export const groupMethods = mapActions('groups', ['fetchAllGroups'])

export const uiMethods = mapActions('ui', ['toggleSidebar', 'checkSidebar'])
